import { render, staticRenderFns } from "./CategoriasListAdmin.vue?vue&type=template&id=0af41272&scoped=true&"
import script from "./CategoriasListAdmin.vue?vue&type=script&lang=js&"
export * from "./CategoriasListAdmin.vue?vue&type=script&lang=js&"
import style0 from "./CategoriasListAdmin.vue?vue&type=style&index=0&id=0af41272&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af41272",
  null
  
)

export default component.exports